/** @jsx jsx */
import { jsx } from "theme-ui"
import { useEffect } from "react"
import axios from "axios"
import { Form as RFForm } from "react-final-form"

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const Form = ({ children, name, onSubmit, ...otherProps }) => {
  let resetFormTimeout

  useEffect(() => {
    return () => {
      clearTimeout(resetFormTimeout)
    }
  }, [resetFormTimeout])

  return (
    <RFForm
      onSubmit={async (values, { setSubmitting, reset }) => {
        const { accept, ...otherValues } = values
        const formValues = { ...otherValues, "form-name": name }

        try {
          await axios.post("/", formValues, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            transformRequest: [encode],
          })

          resetFormTimeout = setTimeout(() => {
            reset()
          }, 3000)

          onSubmit && onSubmit()

          return
        } catch (error) {
          setSubmitting(false)
          return error
        }
      }}
      {...otherProps}
    >
      {({ handleSubmit, ...otherRenderProps }) => (
        <form
          name={name}
          method="POST"
          data-netlify="true"
          onSubmit={handleSubmit}
        >
          {children(otherRenderProps)}
        </form>
      )}
    </RFForm>
  )
}

export default Form
